import * as React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { bool, number, string } from 'prop-types';
import { Colors } from '@airasia-common/libraries/constants';
import ShimmerHotelCard from '../HotelCard/ShimmerHotelCard';
import ShimmerHotelListingPage from '../HotelCard/ShimmerHotelListingPage';
import useWindowSize from '../../utils/windowSize';
const circularRotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const circularDash = keyframes`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0px;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }
  
  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`;

const strokeStyles = css`
  stroke-dasharray: 80px, 200px;
  stroke-dashoffset: 0px;
`;

const Wrapper = styled.div`
  ${strokeStyles}
  display: inline-block;
`;

const SVG = styled.svg`
  display: block;
  animation: ${circularRotate} 1.4s ease-in-out infinite;
`;

const Circle = styled.circle`
  ${strokeStyles}
  animation: ${circularDash} 1.4s ease-in-out infinite;
  stroke: currentColor;
`;
const ShimmerHotelCardWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`;
const HotelCardWrapper = styled.div`
  margin: 8px 0;
`;

const SVG_SIZE = 44;

const ActivityIndicator = ({
  size = 48,
  thickness = 3.6,
  color = Colors.primary,
  empty,
  ...restProps
}) => {
  const url = window?.location?.href;
  const isListingPage = url?.match('/hotel/search');
  const { isMobileView } = useWindowSize();
  return !isMobileView && isListingPage ? (
    <Wrapper id="spinner" role="progressbar">
      {empty === false ? (
        <ShimmerHotelCardWrapper>
          <HotelCardWrapper>
            <ShimmerHotelCard />
          </HotelCardWrapper>
          <HotelCardWrapper>
            <ShimmerHotelCard />
          </HotelCardWrapper>
          <HotelCardWrapper>
            <ShimmerHotelCard />
          </HotelCardWrapper>
          <HotelCardWrapper>
            <ShimmerHotelCard />
          </HotelCardWrapper>
        </ShimmerHotelCardWrapper>
      ) : (
        <ShimmerHotelListingPage isMobileView={isMobileView} />
      )}
    </Wrapper>
  ) : (
    <Wrapper
      id="spinner"
      style={{ width: size, height: size, color, ...restProps }}
      role="progressbar"
    >
      <SVG viewBox={`${SVG_SIZE / 2} ${SVG_SIZE / 2} ${SVG_SIZE} ${SVG_SIZE}`}>
        <Circle
          cx={SVG_SIZE}
          cy={SVG_SIZE}
          r={(SVG_SIZE - thickness) / 2}
          fill="none"
          strokeWidth={thickness}
        />
      </SVG>
    </Wrapper>
  );
};

ActivityIndicator.propTypes = {
  size: number,
  thickness: number,
  color: string,
  empty: bool,
};

export default ActivityIndicator;
